<template>
    <div class="smsMessage">
        <div class="searchForm">
            <el-form ref="form" :model="form" label-width="75px" @submit.native.prevent>
                <el-row :gutter="5">
                    <el-col :span="4">
                        <el-form-item label="批次号" label-width="60px">
                            <el-input v-model="form.batchNumber" autocomplete="off" placeholder="批次号"
                                @keyup.enter.native="getMessageList(1)" />
                        </el-form-item>
                    </el-col>
                    <el-col :span="4">
                        <el-form-item label="手机号" label-width="60px">
                            <el-input v-model="form.phone" autocomplete="off" placeholder="手机号"
                                @keyup.enter.native="getMessageList(1)" />
                        </el-form-item>
                    </el-col>
                    <el-col :span="3">
                        <el-form-item label="发送状态">
                            <el-select v-model="form.status" placeholder="请选择发送状态" clearable @change="getMessageList(1)">
                                <el-option label="全部" value="" />
                                <el-option label="发送成功" value="1" />
                                <el-option label="发送失败" value="2" />
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="7">
                        <el-form-item label="发送日期">
                            <el-date-picker v-model="form.sendTime" type="datetimerange" size="small"
                                :picker-options="pickerOptions" range-separator="-" start-placeholder="开始日期"
                                end-placeholder="结束日期" align="right">
                            </el-date-picker>
                        </el-form-item>
                    </el-col>
                    <el-col :span="2">
                        <el-button style="margin-left: 20px" type="primary" @click="getMessageList(1)">查询</el-button>
                    </el-col>
                </el-row>
            </el-form>
        </div>
        <div class="dataBox">
            <el-table v-loading="loading" element-loading-text="数据加载中" :data="tableData" stripe>
                <el-table-column type="expand">
                    <template slot-scope="scope">
                        <el-form label-position="left" class="table-expand">
                            <el-form-item>
                                <el-row>
                                    <el-col :span="2" class="expandLabel">优先级</el-col>
                                    <el-col :span="21" class="expandContent">{{ parsePriority(scope.row.priority) }}</el-col>
                                </el-row>
                            </el-form-item>
                            <el-form-item>
                                <el-row>
                                    <el-col :span="2" class="expandLabel">模板编码</el-col>
                                    <el-col :span="21" class="expandContent">{{ scope.row.templateCode }}</el-col>
                                </el-row>
                            </el-form-item>
                        </el-form>
                    </template>
                </el-table-column>
                <el-table-column prop="batchNumber" label="消息批次号" width="200px" />
                <el-table-column prop="content" show-overflow-tooltip label="内容" />
                <!--        <el-table-column prop="templateCode" label="模板编码" />-->
                <el-table-column prop="phone" label="接受手机号" width="200" />
                <el-table-column prop="sendTime" sortable label="发送时间" width="200">
                    <template slot-scope="scope">
                        <span>{{ parseTime(scope.row.sendTime) }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="status" label="发送状态" width="140">
                    <template slot-scope="scope">
                        <el-tag :type="scope.row.status === 1 ? 'success' : scope.row.status === 2 ? 'danger' : 'warning'">{{
                            parseStatus(scope.row.status) }}
                        </el-tag>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination background layout="total, sizes, prev, pager, next, jumper" :total="total"
                :page-sizes="[10, 20, 50]" :page-size="pageSize" :current-page.sync="pageNum" @size-change="sizeChangeClick"
                @current-change="currChangeClick" @prev-click="prevClick" @next-click="nextClick" />
        </div>
    </div>
</template>

<script>
import { parsePriority } from "@/util/index";
import { parseTime } from "@/util/index";
import httpUrl from "@/static/configUrl";
export default {
    name: "smsMessage",
    components: {  },
    data() {
        return {
            msg: '大概懂',
            clientId: this.$store.state.request.appId,
            pickerOptions: {
                shortcuts: [{
                    text: '最近一周',
                    onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                        picker.$emit('pick', [start, end]);
                    }
                }, {
                    text: '最近一个月',
                    onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                        picker.$emit('pick', [start, end]);
                    }
                }, {
                    text: '最近三个月',
                    onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                        picker.$emit('pick', [start, end]);
                    }
                }]
            },
            form: {
                phone: '',
                batchNumber: '',
                // searchParam: '',
                type: 2,
                status: '',
                sendTime: []
            },
            tableData: [],
            total: 0,
            pageNum: 1,
            pageSize: 10,
            loading: false,
            dialogEditFormVisible: false,
            dialogFormVisible: false,
        }
    },
    computed: {},
    created() {
        this.initDatePickValue()
        this.getMessageList()
    },
    mounted() {
    },
    methods: {
        parseTime,
        parsePriority,
        parseStatus(status) {
            switch (status) {
                case 1:
                    return "发送成功"
                case 2:
                    return "发送失败"
                case 3:
                    return "待发送"
                default:
                    return "未知状态"
            }
        },
        initDatePickValue() {
            let d = new Date
            this.form.sendTime.push(d)
            let startTime = d.getTime() - 24 * 3600 * 1000 * 30;
            let startDate = new Date(startTime)
            this.form.sendTime.unshift(startDate)
        },
        getMessageList(_pageNum) {
            const that = this
            if (_pageNum === 1) {
                that.pageNum = 1
            }
            that.loading = true
            const _data = {
                curl: httpUrl.messageUrl + '/message/list',
                sendTime: that.form.sendTime,
                clientId: that.clientId,
                phone: that.form.phone,
                batchNumber: that.form.batchNumber,
                // searchParam: that.form.searchParam,
                status: that.form.status,
                type: that.form.type,
                page: that.pageNum,
                size: that.pageSize
            }
            that.$store.dispatch('httpPost', _data).then(function (res) {
                if (res.flag) {
                    that.tableData = res.data.content
                    that.total = res.data.total
                } else {
                    that.$message({
                        message: res.message,
                        type: 'warning'
                    })
                }
                that.loading = false
            }, function (err) {
                console.log(err.message)
                that.loading = false
            })
        },
        // 分页 每页条数改变
        sizeChangeClick(val) {
            this.pageSize = val
            this.getMessageList()
        },
        // 分页 改变当前页
        currChangeClick(val) {
            this.pageNum = val
            this.getMessageList()
        },
        // 分页 上一页
        prevClick(val) {
            this.pageNum = val
            this.getMessageList()
        },
        // 分页 下一页
        nextClick(val) {
            this.pageNum = val
            this.getMessageList()
        }
    }
}
</script>

<style lang="scss" scoped>
.smsMessage {
    .searchForm {
        /*background: #fff;*/
        /*padding-top: 10px;*/
        padding-left: 10px;

        /*height: 45px;*/
        .el-input {
            width: 200px;
        }
    }
}
</style>
<style>
.smsMessage .searchForm .el-form-item {
    display: inline-block;
}

.smsMessage .searchForm .el-form-item:nth-child(2) {
    margin-left: 30px;
}

.smsMessage .table-expand {
    font-size: 0;
}

.smsMessage .table-expand .expandLabel {
    width: 90px;
    color: #99a9bf;
}

.smsMessage .table-expand .expandContent {
    word-break: break-all;
}

.smsMessage .table-expand .el-form-item {
    margin-left: 50px;
    margin-right: 0;
    margin-bottom: 0;
    width: 100%;
}
</style>


